export default {
  // Tabs
  systemTemplate: 'System Templates',
  myTemplate: 'My Templates',
  // Actions
  customCreate: 'Custom Create',
  // Empty state
  emptyMyTemplate: 'No custom templates yet',
  emptyCanvas: 'Drag components here',
  selectComponentTip: 'Click a component in the canvas to edit',
  // Editor
  componentLibrary: 'Component Library',
  propertyPanel: 'Property Panel',
  publicConfig: 'Public Config',
  langConfig: 'Language Config',
  templateManager: 'Template Manager',
  newTemplate: 'New Template',
  cloneTemplate: 'Clone Template',
  deleteTemplate: 'Delete Template',
  templateName: 'Template Name',
  templateType: 'Template Type',
  supportedLangs: 'Supported Languages',
  // Page config
  pageConfig: 'Page Config',
  pageTitle: 'Page Title',
  pageTitlePlaceholder: 'Enter page title',
  canvasConfig: 'Canvas Config',
  bgColor: 'Background Color',
  padding: 'Padding',
  styleConfig: 'Style Config',
  noStyleConfig: 'No style config for this component',
  // Component names
  component_carousel: 'Carousel',
  component_productInfo: 'Product Info',
  component_antiFake: 'Anti-Fake',
  component_traceability: 'Traceability Info',
  component_imageGrid: 'Image Grid',
  component_spacer: 'Spacer',
  component_activityPopup: 'Activity Popup',
  component_videoPlayer: 'Video',
  component_bottomMenu: 'Bottom Menu',
  // Sync lang
  syncLang: 'Sync Config',
  syncLangTitle: 'Sync Config to Other Languages',
  syncLangDesc:
    'Sync current language ({lang}) template config to selected languages. Target language configs will be overwritten.',
  syncLangSuccess: 'Sync config successfully',
};
